export const FETCH_DOMAIN_NOTES_REQUEST = 'FETCH_DOMAIN_NOTES_REQUEST';
export const FETCH_DOMAIN_NOTES_SUCCESS = 'FETCH_DOMAIN_NOTES_SUCCESS';
export const FETCH_DOMAIN_NOTES_FAILURE = 'FETCH_DOMAIN_NOTES_FAILURE';

export const POST_DOMAIN_NOTE_REQUEST = 'POST_DOMAIN_NOTE_REQUEST';
export const POST_DOMAIN_NOTE_SUCCESS = 'POST_DOMAIN_NOTE_SUCCESS';
export const POST_DOMAIN_NOTE_FAILURE = 'POST_DOMAIN_NOTE_FAILURE';
